export function eventListenerOrTimeout(
	eventName: string | false,
	element: Element,
	callback: () => void,
	fallbackDuration = 0,
	remove = true
): void {
	if (eventName === false) {
		setTimeout(() => {
			callback();
		}, fallbackDuration);
	} else {
		let called = false;
		const listener = () => {
			called = true;
			if (remove) {
				element.removeEventListener(eventName, listener);
			}
			callback();
		};
		element.addEventListener(eventName, listener);
		if (fallbackDuration) {
			setTimeout(() => {
				if (!called) {
					element.dispatchEvent(new CustomEvent(eventName));
				}
			}, fallbackDuration);
		}
	}
}
